import styled from "styled-components/macro";

export const PageWrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 85%;
  margin: 20px 0;
`;

export const Text = styled.p`
  margin-bottom: 20px;
  font-size: 18px;
  padding: 5px;
`;

export const EmailLink = styled.a`
  transition: all 0.3s;
  color: #ae350a;
  cursor: pointer;
`;
